import React from 'react';
import { IconSvgProps } from '@models/common';

const Add: React.FC<IconSvgProps> = (props) => {
  const { size = 41, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      stroke='currentColor'
      fill='none'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M15.5 20.5h10M20.5 15.5v10M20.5 35.5a15 15 0 1 0 0-30 15 15 0 0 0 0 30Z'
      />
    </svg>
  );
};

export default Add;
